const FireSvg = ({ size = 8 }) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={`-m-[3px] size-${size}`}
  >
    <path
      d="M10.2415 3.97598C12.1618 4.83404 13.5 6.76075 13.5 9.00001C13.5 12.0376 11.0376 14.5 8 14.5C4.96243 14.5 2.5 12.0376 2.5 9.00001C2.5 7.52531 3.08039 6.18617 4.02521 5.19855C4.5362 5.91215 5.21366 6.49845 6.00081 6.90067C6.03088 5.05022 6.89865 3.40343 8.24141 2.323C8.75035 3.0055 9.42525 3.57905 10.2415 3.97598Z"
      stroke="#A63233"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12.5003C9.38071 12.5003 10.5 11.381 10.5 10.0003C10.5 8.7314 9.5547 7.68332 8.32993 7.52185C7.65771 8.12488 7.1908 8.95216 7.04687 9.88602C6.52513 9.75848 6.04353 9.5286 5.62455 9.21886C5.54372 9.4647 5.5 9.72738 5.5 10.0003C5.5 11.381 6.61929 12.5003 8 12.5003Z"
      stroke="#A63233"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FireSvg;
